import { faChartLine, faFire, IconDefinition } from '@fortawesome/free-solid-svg-icons';

import { TrainerFlairSlugEnum } from '@rover/rsdk/src/apiClient/latest/model/trainerFlairSlugEnum';
import { Logger } from '@rover/rsdk/src/modules/Logging';

const DEFAULT_FLAIR_ICON = faFire;

const FLAIR_ICON_MAP: Record<TrainerFlairSlugEnum, IconDefinition> = {
  'trainer-flair-popular': faFire,
  'trainer-flair-trending': faChartLine,
};

export function getFlairIconBySlug(flairSlug: TrainerFlairSlugEnum): IconDefinition {
  const icon = FLAIR_ICON_MAP[flairSlug];
  if (!icon) {
    Logger.warn(`No icon found for trainer flair slug: ${flairSlug}`);
    return DEFAULT_FLAIR_ICON;
  }

  return icon;
}
